import * as Preact from 'preact'
import { Link, Match } from 'preact-router/match'
import { FadeIn } from '../../lib/FadeIn'

const { h } = Preact

interface IReactLoadableLoaderProps {
  error: boolean
  retry: () => void
  timedOut: boolean
  pastDelay: boolean
}

const LoadableLoader = (props: IReactLoadableLoaderProps) => {
  if (props.error) {
    console.log(props.error)

    return (
      <FadeIn>
        Det skjedde en feil! <button onClick={props.retry}>Prøv igjen</button>
      </FadeIn>
    )
  } else if (props.timedOut) {
    return (
      <FadeIn>
        Dette tok for lang tid!{' '}
        <button onClick={props.retry}>Prøv igjen</button>
      </FadeIn>
    )
  } else if (props.pastDelay) {
    return <FadeIn>Laster...</FadeIn>
  } else {
    return null
  }
}

const Loader = () => {
  return <FadeIn>Laster...</FadeIn>
}

export { LoadableLoader, Loader }
